import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import { IconButton, Typography, Chip, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faUsers } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import DeleteDialog from "../../../../components/DeleteDialog";

export default function PlansDataTable({ plans, onDeletePlan, isLoading }) {
    const history = useHistory();

    const [plan,setPlan] = useState(null);

    const [openDeleteDialog,setOpenDeleteDialog] = useState(false);

    const handleOpenDialog = (planToRemove) => {
        setPlan(planToRemove);
        setOpenDeleteDialog(true);
    }

    // Helper para traducir la frecuencia
    const formatFrequency = (count, interval) => {
        const map = { day: 'Días', week: 'Semanas', month: 'Meses', year: 'Años' };
        const singularMap = { day: 'Día', week: 'Semana', month: 'Mes', year: 'Año' };
        
        if (count === 1) return `Cada ${singularMap[interval]}`;
        return `Cada ${count} ${map[interval]}`;
    };

    const columns = [
        {
            name: 'id',
            label: 'ID',
            options: { display: false } // Opcional: ocultar ID
        },
        {
            name: 'name',
            label: 'Nombre del Plan',
        },
        {
            name: 'price',
            label: 'Precio',
            options: {
                customBodyRender: (value) => (
                    <Typography fontWeight="bold">${parseFloat(value).toFixed(2)}</Typography>
                )
            }
        },
        {
            name: 'billing_interval', // Usamos este campo base para renderizar la combinación
            label: 'Frecuencia',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    const plan = plans[dataIndex];
                    return formatFrequency(plan.interval_count, plan.billing_interval);
                }
            }
        },
        {
            name: 'status',
            label: 'Estado',
            options: {
                customBodyRender: (value) => (
                    <Chip 
                        label={value ? "Activo" : "Inactivo"} 
                        color={value ? "success" : "default"} 
                        size="small" 
                    />
                )
            }
        },
        {
            name: 'actions',
            label: 'Acciones',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    const planId = plans[dataIndex].id;
                    return (
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                            {/* Botón: Ver Suscriptores */}
                            <Tooltip title="Ver Suscriptores">
                                <IconButton 
                                    color="link" 
                                    onClick={() => history.push(`/subscriptions/plans/detail/${planId}`)}
                                >
                                    <FontAwesomeIcon icon={faUsers} />
                                </IconButton>
                            </Tooltip>

                            {/* Botón: Editar */}
                            <Tooltip title="Editar Plan">
                                <IconButton 
                                    color="default"
                                    onClick={() => history.push(`/subscriptions/plans/edit/${planId}`)}
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                </IconButton>
                            </Tooltip>

                            {/* Botón: Eliminar */}
                            <Tooltip title="Eliminar">
                                <IconButton 
                                    color="error" 
                                    onClick={() => handleOpenDialog(plans[dataIndex])}
                                >
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </IconButton>
                            </Tooltip>
                        </div>
                    );
                },
                filter: false,
                sort: false,
            }
        }
    ];

    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
        elevation: 1, // Para que se vea más limpio dentro del Paper del padre
    };

    return (
        <>
            <MUIDataTable
                title={"Mis Planes"}
                data={plans}
                columns={columns}
                options={options}
            />
            <DeleteDialog
                open={openDeleteDialog}
                title={`Eliminar Plan`}
                message={`Seguro que desas eliminar el plan: ${plan?plan.name:''}`}
                onClose={()=> setOpenDeleteDialog(false)}
                onConfirm={ async () => {
                    await onDeletePlan(plan.id);
                    setOpenDeleteDialog(false);
                }}
                isLoading={isLoading}
            />
        </>
    );
}